/* eslint-disable camelcase */

import * as React from 'react';

type Locale = 'en' | 'es';

type Phrase = (
  locale: Locale,
  params: {
    transformFn: React.FC<{ text: string }>;
  },
) => React.ReactNode;

export const i18n_topics_include_ayurveda_longevity_anatomy_physiology_mantras_and_mudras_spirituality_yin: Phrase =
  (locale, { transformFn }) => {
    const en = (
      <>
        {transformFn({ text: `Topics Include:` })} Ayurveda, Longevity, Anatomy & Physiology,
        Mantras and Mudras, Spirituality, Pregnancy, Yoga Therapy, Tantra, Yin, Sequencing and so
        much more.
      </>
    );
    const phrases: { [key: string]: undefined | React.ReactNode } = {
      en,
      es: (
        <>
          {transformFn({ text: `Algunos temas incluidos:` })} Ayurveda, chakras, kundalini,
          espiritualidad, yoga prenatal, yoga terapéutico, tantra y mucho más.
        </>
      ),
    };
    return phrases[locale] || en;
  };
